let promise = Promise.resolve();
let mutateWithTask;
let currTask;

export default function nextTick(task) {
    currTask = task;
    if (mutateWithTask) {
        mutateWithTask();
    } else {
        promise = promise.then(task);
    }
}

if (typeof MutationObserver !== "undefined") {
    let counter = 0;
    const observer = new MutationObserver(onTask);
    const textNode = document.createTextNode(String(counter));
    observer.observe(textNode, { characterData: true });

    mutateWithTask = function mutateWithTask() {
        counter = (counter + 1) % 2;
        textNode.textContent = counter;
    };
}

function onTask() {
    if (currTask) {
        currTask();
    }
}



// WEBPACK FOOTER //
// ./src/utils/nextTick.js